import ReactDOM from 'react-dom';
import { usePortal } from './hooks';
export function Portal(props) {
  var portal = usePortal();

  if (!portal.element) {
    return null;
  }

  return ReactDOM.createPortal(props.children, portal.element);
}